// extracted by mini-css-extract-plugin
module.exports = {"benefit":"Benefit_benefit__NZ2sI","benefit__preview":"Benefit_benefit__preview__E9wl_","benefit__preview-in":"Benefit_benefit__preview-in__GGajy","lottie":"Benefit_lottie__jJXXj"};